module.exports = __webpack_public_path__ + "static/media/wet_snow.f225c5ef.svg";